import { useContext } from 'react';

import { PublishedQSetListContext } from './published-qset-list-modal-provider';

function usePublishedQSetListModal() {
  const context = useContext(PublishedQSetListContext);

  if (!context) {
    throw new Error(
      'usePublishedQSetListModal must be used within a PublishedQSetListModalProvider',
    );
  }

  return context;
}

export { usePublishedQSetListModal };
